import React from 'react';
import { Container, Box, Typography, Grid, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { theme, commonStyles } from '../../../styles/theme';
import { documentationSections } from './homePageData.jsx';

const DocumentationTab = () => {
	const quickLinks = [
		{ title: 'Getting Started', link: '#getting-started' },
		{ title: 'Layer Management', link: '#layer-management' },
		{ title: 'Rarity Configuration', link: '#rarity-configuration' },
		{ title: 'Decision Trees & Paths', link: '#decision-trees-paths' },
		{ title: 'Rules Engine', link: '#rules-engine' },
		{ title: 'Preview & Testing', link: '#preview-testing' },
		{ title: 'Generation & Export', link: '#generation-export' },
		{ title: 'Team Collaboration', link: '#team-collaboration' },
		{ title: 'Payment & Licensing', link: '#payment-licensing' },
		{ title: 'Advanced Features', link: '#advanced-features' },
	];

	return (
		<Container maxWidth="lg" sx={{ py: { xs: 4, md: 8 }, px: { xs: 2, sm: 3 } }}>
			<Box sx={{ textAlign: 'center', mb: { xs: 4, md: 8 } }}>
				<Typography variant="h3" sx={{ fontWeight: 800, color: theme.colors.textPrimary, mb: 2 }}>
					Documentation
				</Typography>
				<Typography variant="body1" sx={{ color: theme.colors.textSecondary, maxWidth: 700, mx: 'auto', lineHeight: 1.7 }}>
					Comprehensive guides and tutorials for every feature
				</Typography>
			</Box>

			{/* Quick Links Panel */}
			<Box sx={{ mb: { xs: 3, md: 4 } }}>
				<Typography variant="h5" sx={{ fontWeight: 700, color: '#fff', mb: 2 }}>
					Quick Links
				</Typography>
				<Grid container spacing={1.5}>
					{quickLinks.map((linkItem, idx) => (
						<Grid item xs={12} sm={6} md={4} key={idx}>
							<Box
								component="a"
								href={linkItem.link}
								sx={{
									textDecoration: 'none',
									color: '#fff',
									display: 'block',
									'&:hover': { color: theme.colors.primary }
								}}
							>
								<Typography variant="body2" sx={{ fontSize: '0.95rem' }}>
									{linkItem.title}
								</Typography>
							</Box>
						</Grid>
					))}
				</Grid>
			</Box>

			{/* Documentation Sections */}
			{documentationSections.map((section) => (
				<Box key={section.id} id={section.id} sx={{ mb: 4 }}>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
						<Box sx={{ color: section.color }}>
							{section.icon}
						</Box>
						<Typography variant="h5" sx={{ fontWeight: 700, color: section.color }}>
							{section.title}
						</Typography>
					</Box>
					<Grid container spacing={2}>
						{section.topics.map((topic, idx) => (
							<Grid item xs={12} key={idx}>
								<Accordion 
									elevation={0}
									sx={{
										...commonStyles.card,
										borderRadius: '8px !important',
										'&:before': { display: 'none' },
										'&:hover': {
											borderColor: section.color,
											transform: 'translateX(4px)'
										},
										'&.Mui-expanded': {
											borderColor: section.color,
											boxShadow: `0 4px 16px ${section.color}33`
										},
										transition: 'all 0.3s'
									}}
								>
									<AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: section.color }} />}>
										<Typography variant="body1" sx={{ fontWeight: 600, color: '#fff' }}>
											{topic.q}
										</Typography>
									</AccordionSummary>
									<AccordionDetails sx={{ borderTop: `1px solid ${section.color}33`, pt: 2 }}>
										<Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)', lineHeight: 1.7 }}>
											{topic.a}
										</Typography>
									</AccordionDetails>
								</Accordion>
							</Grid>
						))}
					</Grid>
				</Box>
			))}
		</Container>
	);
};

export default DocumentationTab;
